import React from "react";

const CompatibilityRing = ({ value = 0, size = 120, stroke = 4, label = "Compatibilidade" }) => {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (Math.max(0, Math.min(100, value)) / 100) * circ;

  return (
    <div className="inline-flex flex-col items-center gap-2" data-testid="compatibility-ring">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size/2} cy={size/2} r={radius} stroke="#2A2D35" strokeWidth={stroke} fill="none" />
          <circle
            cx={size/2} cy={size/2} r={radius}
            stroke="#C5A880"
            strokeWidth={stroke}
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circ}
            strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset 800ms ease-out" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-display text-3xl text-[#F5F2EE]">{value}<span className="text-sm gold-text">%</span></span>
        </div>
      </div>
      {label && <span className="label-uppercase">{label}</span>}
    </div>
  );
};

export default CompatibilityRing;
